import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/dltravels/node_modules/lucide-react/dist/esm/Icon.mjs");
